export const HREF_LEVEL = 'level'
export const HREF_MENU = 'menu'
export const PATH_LEVEL = 'levelNum'
export const PATH_LEVEL_CREATE = 'create'
export const PATH_LEVEL_EDIT = 'edit'
